/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_Empty_WriteInputs */

const en_recipes_empty_write = /** @type {(inputs: Recipes_Empty_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write one yourself`)
};

const de_recipes_empty_write = /** @type {(inputs: Recipes_Empty_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selbst eines schreiben`)
};

/**
* | output |
* | --- |
* | "Write one yourself" |
*
* @param {Recipes_Empty_WriteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_empty_write = /** @type {((inputs?: Recipes_Empty_WriteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_Empty_WriteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_empty_write(inputs)
	return en_recipes_empty_write(inputs)
});